export default __webpack_public_path__ + "static/aikido-uros-9ffa36b1c1b33eba3b6e886e25abb428.jpg";